var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.wrapperClasses,attrs:{"disabled":_vm.disabled,"checked":_vm.currentChecked}},[_c('input',{ref:"input",class:_vm.inputClasses,attrs:{"type":"radio","disabled":_vm.disabled},domProps:{"checked":_vm.currentChecked},on:{"change":_vm.$_onChange}}),_vm._v(" "),_c('span',{class:_vm.innerClasses},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2635d734","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/radio/radio.vue
// module id = 554
// module chunks = 0 1 35